﻿import buttonLoader from '../../utilities/buttonLoader.js';
import timetable_register from './timetableRegister.js';

var classWaitingRegister = {};

classWaitingRegister = {

  init: function () {

    var me = this;
    var form = document.getElementsByClassName('classWaitingRegisterForm')[0];

    if (form) {
      me.bind(form);
    }

  },

  bind: function (form) {
    var me = this;

    form.addEventListener('submit', function (e) {

      e.preventDefault();

      var m = form.querySelector('.alert');

      if (m) {
        m.remove();
      }

      me.submit(form);

    });

    var termCheckbox = document.getElementById('classWaiting__terms');

    if (termCheckbox) {
      termCheckbox.addEventListener('change', function (e) {

        var checked = e.target.checked;

        if (checked) {
          form.querySelector('button[type=submit]').removeAttribute('disabled');
        } else {
          form.querySelector('button[type=submit]').setAttribute('disabled', 'disabled');
        }

      });
    }


  },

  submit: function (form) {
    var me = this;

    var button = form.querySelector('button[type=submit]');

    buttonLoader.start(button);

    var data = new FormData(form);

    var xhr = new XMLHttpRequest();
    xhr.open(form.getAttribute("method"), form.getAttribute("action"));

    xhr.onload = function () {

      var resp = JSON.parse(xhr.response);

      if (xhr.status >= 200 && xhr.status < 300) {

        if (resp.success) {

          buttonLoader.success(button);

          var modal = document.getElementsByClassName('modal__rulesWaiting')[0];

          if (modal) {
            var itemId = form.querySelector('input[name=itemId]').value;
            var timeTablebutton = document.querySelector('button[data-itemId="' + itemId + '"]');
            
            timeTablebutton.querySelector('span').innerText = timeTablebutton.getAttribute('data-defaultUnsubscribe');
            timeTablebutton.classList.add('button--burgundy', 'action-unsubscribe-class', 'action-unsubscribe-waitinglist-class');
            timeTablebutton.classList.remove('button--primary', 'action-register-class');

            var buttonClone = timeTablebutton.cloneNode(true);
            timeTablebutton.parentNode.replaceChild(buttonClone, timeTablebutton);

            timetable_register.Unsubscribe.bindClasses(buttonClone);

            modal.classList.remove('modal--show');
          }

        } else {

          buttonLoader.reset(button);

          me.renderMessage(button, resp.message, 'error');
        }

      } else {

        buttonLoader.reset(button);

        me.renderMessage(button, 'Server error', 'error');
      }

    };

    xhr.send(data);
  },

  renderMessage: function (el, message, type) {
    el.insertAdjacentHTML('beforebegin', '<div class="alert ' + type + '">' + message + '</div>');

  }
};


classWaitingRegister.initialize = function () {
  classWaitingRegister.init();
};

module.exports = classWaitingRegister;
